/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
  updatePrices: (componentRegistry) => {
    let formatMoneyHelper;

    componentRegistry.useComponentPlugin("FormatCurrency", {
      apply: () => ({
        afterRender(element) {
          if (!formatMoneyHelper) {
            formatMoneyHelper = element.getHelpers().formatMoney;
          }
        },
      }),
    });

    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Modify Product Prices",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          if (formatMoneyHelper) {
            // formatMoneyHelper
            console.log(formatMoneyHelper);

            const data = element.getParams().props.product;
            const origin_price = parseFloat(data.price_min);
            const tax_price = parseFloat(data.price_min * 1.1);

            const newHtml =
              `<div class="boost-sd__product-price-content boost-sd__product-price-content--row-reverse boost-sd__product-price-content--text-align-left">
               ${formatMoneyHelper(origin_price)}(税抜) /<br class="sp-only"> ${formatMoneyHelper(tax_price)}(税込) 
              </div>`

            const productItem = data.hasOwnProperty("split_product")
              ? document.querySelector(
                  '[data-product-id="' + data.variant_id + '"]'
                )
              : document.querySelector('[id="' + data.id + '"]');
            productItem
              .querySelector(".boost-sd__product-price-wrapper")
              .classList.add("boost-sd-meta-price");
            productItem.querySelector(
              ".boost-sd__product-price-wrapper"
            ).innerHTML = newHtml;
          }
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updatePrices,
]);
